module.exports = __webpack_public_path__ + "img/finland.6a265499.png";